import { render, staticRenderFns } from "./depositFreeFinnish.vue?vue&type=template&id=1d899bac&scoped=true"
import script from "./depositFreeFinnish.vue?vue&type=script&lang=js"
export * from "./depositFreeFinnish.vue?vue&type=script&lang=js"
import style0 from "./depositFreeFinnish.vue?vue&type=style&index=0&id=1d899bac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d899bac",
  null
  
)

export default component.exports